<template>
    <div>
        <loading-spinner v-if="loading"></loading-spinner>
        <template v-else>
            <div class="container">
                <div class="motability-details__header-container">
                    <gallery class="motability-details__gallery-container" />
                    <div class="motability-details__header-right-col">
                        <div class="rd-card rd-card--border-top motability-details__title-card"  :class="{
                                'motability-details__title-card--animate-in': animateIn,
                                'motability-details__title-card-ds': vehicle.brand === 'ds'
                            }">
                            <div :class="{'motability-details__title-card--inner-ds': vehicle.brand === 'ds'}">
                                <h1 class="motability-details__title-h1">{{ modelTitle }}</h1>
                                <h2 class="motability-details__title-h2">{{ vehicle.bodystyle }} {{ vehicle.version }}</h2>

                                <div class="pill-toggle pill-toggle--m-b pill-toggle--full-width">
                                    <div class="pill-toggle pill-toggle--full-width new-details-pill-toggle__inner-bg">
                                        <div class="pill-toggle__pill" @click="handleToggleChange('civilian')" >
                                            <input class="pill-toggle__input new-details-pill-toggle__input" type="radio" v-model="civilianSelected" :value="true" autocomplete="off" id="civilianQuote"/>
                                            <label class="pill-toggle__label new-details-pill-toggle__label new-details-pill-toggle__label--electric" for="discoverElectric">Civilian Quote </label>
                                        </div>
                                        <div class="pill-toggle__pill" @click="handleToggleChange('war')">
                                            <input class="pill-toggle__input new-details-pill-toggle__input" type="radio" v-model="civilianSelected" :value="false" autocomplete="off" id="warPensionQuote"/>
                                            <label class="pill-toggle__label new-details-pill-toggle__label" for="viewAllEngines">War Pension Quote</label>
                                        </div>
                                    </div>
                                </div>

                                <div class="motability-details__pricing-container">
                                    <div>
                                        <label class="motability-details__pricing-label">
                                            <span v-if="civilianSelected">Civillian Weekly Allowance</span>
                                            <span v-else >War Pension Quote</span></label>
                                        <p class="motability-details__pricing-value">
                                            <span v-if="civilianSelected">{{ vehicle.motab_civ_allowance_formatted }}</span>
                                            <span v-else >{{ vehicle.motab_war_allowance_formatted }} </span>
                                        </p>
                                    </div>
                                    <div>
                                        <label class="motability-details__pricing-label">Advance Payment</label>
                                        <p class="motability-details__pricing-value motability-details__pricing-value--adv">
                                            <span v-if="civilianSelected">£{{ NumberFormat(vehicle.motab_civ_advance_payment) }}</span>
                                            <span v-else>£{{ NumberFormat(vehicle.motab_war_advance_payment) }}</span>
                                        </p>

                                    </div>
                                </div>

                                <div class="motability-details__ctas">
                                    <a class="btn btn--primary" @click="scrollToEnquireNow">Enquire Now</a>
                                    <a class="link link--secondary link--is-button link--has-icon link--centered" @click="scrollToValuation">Value My Car</a>
                                </div>
                            </div>
                        </div>
                        <div class="motability-details__exclusive-offer" v-if="vehicle.motab_offer_message" v-html="vehicle.motab_offer_message"></div>
                    </div>
                </div>
            </div>
            <div class="bg bg--light-blue">
                <div class="container">
                    <h2 class="motability-details__h2">Key Specification</h2>
                    <div class="motability-details__key-specs">
                        <div class="motability-details__key-spec-item">
                            <img class="motability-details__key-spec-icon" src="/images/new/details/powertrain-electric-icon.svg" alt="Fuel Type" />
                            <span class="motability-details__key-spec-label">Fuel type:</span>
                            <span class="motability-details__key-spec-value">{{ vehicle.fuel_type }}</span>
                        </div>
                        <div class="motability-details__key-spec-item" v-if="vehicle.max_ev_range > 0">
                            <img class="motability-details__key-spec-icon" src="/images/new/details/range-icon.svg" alt="Max Range" />
                            <span class="motability-details__key-spec-label">Max range:</span>
                            <span class="motability-details__key-spec-value">{{ NumberFormat(vehicle.max_ev_range, 0) }} miles</span>
                        </div>
                        <div class="motability-details__key-spec-item">
                            <img class="motability-details__key-spec-icon" src="/images/new/details/transmission-icon.svg" alt="Transmission" />
                            <span class="motability-details__key-spec-label">Transmission:</span>
                            <span class="motability-details__key-spec-value">{{ vehicle.transmission }}</span>
                        </div>
                        <div class="motability-details__key-spec-item">
                            <img class="motability-details__key-spec-icon" src="/images/new/details/bodystyle-icon.svg" alt="Body style" />
                            <span class="motability-details__key-spec-label">Body style:</span>
                            <span class="motability-details__key-spec-value">{{ vehicle.friendly_bodystyle }}</span>
                        </div>
                        <div class="motability-details__key-spec-item" v-if="maxChargeTime" :title="maxChargeTimeMessage">
                            <img class="motability-details__key-spec-icon" src="/images/new/details/max-charge-time.svg" alt="Max charge time" />
                            <span class="motability-details__key-spec-label">Max charge time:</span>
                            <span class="motability-details__key-spec-value">{{ niceMaxChargeTime }}</span>
                        </div>
                        <div class="motability-details__key-spec-item" v-if="quickChargeTime" :title="quickChargeTimeMessage">
                            <img class="motability-details__key-spec-icon" src="/images/new/details/quick-charge-time.svg" alt="Quick charge time" />
                            <span class="motability-details__key-spec-label">Quick charge time:</span>
                            <span class="motability-details__key-spec-value">{{ niceQuickChargeTime }}</span>
                        </div>
                        <div class="motability-details__key-spec-item">
                            <img class="motability-details__key-spec-icon" src="/images/new/details/seats.svg" alt="Seats" />
                            <span class="motability-details__key-spec-label">Seats:</span>
                            <span class="motability-details__key-spec-value">{{ vehicle.seats }}</span>
                        </div>
                        <div class="motability-details__key-spec-item" v-if="vehicle.insurance_scale">
                            <img class="motability-details__key-spec-icon" src="/images/new/details/insurance.svg" alt="Insurance" />
                            <span class="motability-details__key-spec-label">Insurance:</span>
                            <span class="motability-details__key-spec-value">{{ vehicle.insurance_scale }}</span>
                        </div>
                        <div class="motability-details__key-spec-item" v-if="vehicle.co2 > 0">
                            <img class="motability-details__key-spec-icon" src="/images/new/details/co2.svg" alt="CO2 Emissions" />
                            <span class="motability-details__key-spec-label">CO2:</span>
                            <span class="motability-details__key-spec-value">{{ NumberFormat(vehicle.co2, 0) }} g/km</span>
                        </div>
                        <div class="motability-details__key-spec-item" v-if="vehicle.engine_size > 1">
                            <img class="motability-details__key-spec-icon" src="/images/new/details/engine.svg" alt="Engine capacity" />
                            <span class="motability-details__key-spec-label">Engine size:</span>
                            <span class="motability-details__key-spec-value">{{ NumberFormat(vehicle.engine_size, 0) }} CC</span>
                        </div>
                        <div class="motability-details__key-spec-item" v-if="luggageCapacity" :title="luggageCapacity.name">
                            <img class="motability-details__key-spec-icon" src="/images/new/details/luggage.svg" alt="Luggage capacity" />
                            <span class="motability-details__key-spec-label">Luggage capacity:</span>
                            <span class="motability-details__key-spec-value">{{ NumberFormat(luggageCapacity.value, 0) }} L</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bg" v-if="standardSpec || techSpecs">
                <div class="container">
                    <h2 class="motability-details__h2">Full Vehicle Specification</h2>
                    <h3 class="motability-details__full-spec-h3">For {{ vehicle.vehicle_title }}</h3>
                    <div class="motability-details__swiper-container">
                        <div class="motability-details__swiper-btn motability-details__swiper-prev" ref="swiper-prev"></div>
                        <div class="swiper motability-details__swiper" ref="specButtons">
                            <div class="swiper-wrapper configurator__buttons-wrapper">
                                <button v-for="(spec, label) in standardSpec" :key="label" type="button" class="swiper-slide btn btn--blue-inverted motability-details__spec-btn" :class="{'motability-details__spec-btn--selected': standardSpecSelected == label}" @click="standardSpecSelected = label">{{ label }}</button>
                                <button type="button" class="swiper-slide btn btn--blue-inverted motability-details__spec-btn" :class="{'motability-details__spec-btn--selected': standardSpecSelected == 'General'}" @click="standardSpecSelected = 'General'">General</button>
                            </div>
                        </div>
                        <div class="motability-details__swiper-btn motability-details__swiper-next" ref="swiper-next"></div>
                    </div>
                    <div class="motability-details__full-spec-values-container">
                        <div v-for="(spec, label) in standardSpec" v-show="standardSpecSelected == label && label != 'Options'" :key="label + '.items'" class="motability-details__spec-item-container">
                            <div v-for="(item, index) in spec" class="motability-details__spec-item motability-details__spec-item-value" :key="label + '.' + index + '.item'" v-html="item"></div>
                        </div>
                        <optional-extras v-show="standardSpecSelected == 'Options'"></optional-extras>
                        <tech-specs v-show="standardSpecSelected == 'General'"></tech-specs>
                    </div>
                </div>
            </div>

            <div class="bg" ref="enquire-now">
                <div class="container">
                    <enquire-now class="rd-card rd-card--border-top" :isMotability="true" @scroll-to-valuation="scrollToValuation"></enquire-now>
                </div>
            </div>

            <div class="bg" ref="valuation">
                <div class="container">
                    <valuation-tool />
                </div>
            </div>

            <div class="bg" ref="stock" v-if="haveNewVehiclesInStock">
                <new-cars-in-stock class="container" />
            </div>

            <benefits />

            <div class="cms-content-get-in-touch bg bg--rd-stellantis-pop-blue">
                <div class="container">
                    <div class="cms-content-get-in-touch__headings">
                        <p class="cms-content-get-in-touch__heading">Get in touch</p>
                        <p>We are available Mon - Fri: 8am - 7pm, Sat 8am - 5:30pm and Sun: 10am - 5pm</p>
                    </div>
                    <div class="cms-content-get-in-touch__sections" id="cms-content-get-in-touch-{!! $CMSContentSlice->id !!}">
                        <a href="#live-chat" @click.prevent="openLiveChat" class="cms-content-get-in-touch__section">
                            <svg class="cms-content-get-in-touch__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 86.5 86.5">
                                <g fill="none" fill-rule="evenodd" transform="translate(.3 .3)">
                                    <path fill="#FFF" fill-rule="nonzero"
                                        d="M61.9 24H34.2a8 8 0 0 0-8 8v22.8l-3.9 3.4V31.7c0-6.3 5.3-11.4 11.6-11.4h22a6 6 0 0 1 3.4 1.1c.5.4 1.2.3 1.6-.2.4-.5.3-1.3-.2-1.6a8 8 0 0 0-4.8-1.6h-22C26.3 18 20 24.1 20 31.7v29.1c0 .5.3.9.7 1 .5.3 1 .2 1.3-.1l4.1-3.7v8.8a1.2 1.2 0 0 0 2 .9l6.8-6.2.6-.5.7-.6h25.7c4.5 0 8.1-3.7 8.1-8.1V32a8 8 0 0 0-8.1-8Zm5.8 28.3c0 3.1-2.6 5.7-5.8 5.7H37.2c-1.8 0-2 0-3.3 1.3l-.6.5-4.8 4.4V32c0-3.1 2.5-5.7 5.7-5.7H62c3.2 0 5.8 2.6 5.8 5.7v20.3Z" />
                                    <circle cx="43" cy="43" r="43" stroke="#FFF" stroke-width=".5" opacity=".6" />
                                </g>
                            </svg>

                            <div>
                                <p class="cms-content-get-in-touch__content-heading">Live Chat</p>
                                <p class="cms-content-get-in-touch__content-text">Start a conversation</p>
                            </div>
                        </a>
                        <a href="tel:02476851406" class="cms-content-get-in-touch__section">
                            <img src="/images/new/details/phone.svg" class="cms-content-get-in-touch__icon" alt="" />
                            <div>
                                <p class="cms-content-get-in-touch__content-heading">Call Us</p>
                                <p class="cms-content-get-in-touch__content-text">024 7685 1406</p>
                            </div>
                        </a>
                        <a :href="'/dealer-locator?brand=' + vehicle.brand" class="cms-content-get-in-touch__section">
                            <img src="/images/new/details/contact-us.svg" class="cms-content-get-in-touch__icon" alt="" />
                            <div>
                                <p class="cms-content-get-in-touch__content-heading">Contact Us</p>
                                <p class="cms-content-get-in-touch__content-text">Find your local dealership</p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import Swiper, {Navigation} from "swiper";

import LoadingSpinner from '../../core/components/LoadingSpinner.vue';
import Gallery from '../../new-vue/components/details/Gallery.vue';
import TechSpecs from '../../new-vue/components/details/TechSpecs.vue';
import OptionalExtras from '../../new-vue/components/details/OptionalExtras.vue';
import EnquireNow from '../../new-vue/components/details/EnquireNow.vue';
import Benefits from '../../new-vue/components/details/Benefits.vue';
import NewCarsInStock from '../../new-vue/components/details/NewCarsInStock.vue';
import ValuationTool from '../../valuation-tool/ValuationTool.vue';

import { mapState } from 'vuex';
import NumberFormat from "../../used-vue/api/NumberFormat";
import { trackPageView } from "../../modules/tracking/AnalyticsEvents";

export default {
    components: {
        LoadingSpinner,
        Gallery,
        TechSpecs,
        OptionalExtras,
        ValuationTool,
        NewCarsInStock,
        EnquireNow,
        Benefits
    },
    props: {
        id: {
            required: true,
        },
        brand: {
            required: true,
        },
    },
    data() {
        return {
            firstLoad: true,
            loading: true,
            showSelectModel: false,
            standardSpecSelected: null,
            shouldAttachFinance: false,
            animationTimeout: null,
            animateIn: false,
            civilianSelected: true,

        };
    },
    methods: {
        NumberFormat,

        handleToggleChange(type) {
            this.civilianSelected = (type === 'civilian') ? true : false;
        },
        switchToModel(modelToSwitchTo) {
            if (this.id == modelToSwitchTo.id) {
                return;
            }
            this.$router.push({ name: 'motability-details', params: {brand: this.vehicle.brand, id: modelToSwitchTo.id, slug: modelToSwitchTo.slug}});
        },
        scrollToEnquireNow() {
            VueScrollTo.scrollTo(this.$refs["enquire-now"], 500);
        },
        scrollToValuation() {
            VueScrollTo.scrollTo(this.$refs["valuation"], 500);
        },
        scrollToNewVehiclesInStock() {
            VueScrollTo.scrollTo(this.$refs["stock"], 500);
        },
        applyForFinance() {
            this.shouldAttachFinance = true;
            VueScrollTo.scrollTo(this.$refs["enquire-now"], 500);
        },
        openLiveChat() {
            window.liveChatClass.openLiveChat();
        },
        init(){
            this.$store.commit('Layout/setBrand', this.brand);
            this.$store.dispatch('NewVehicleData/getVehicleData', this.id)
            .then((response) => {
                this.loading = false;
                let title = `New ${this.modelTitle} ${this.vehicle.bodystyle} ${this.vehicle.version} | Stellantis &You UK`;
                if (title.toLocaleLowerCase().substring(0, 7) == 'new new') {
                    title = `${this.modelTitle} ${this.vehicle.bodystyle} ${this.vehicle.version} | Stellantis &You UK`;
                }
                document.querySelector('title').innerHTML = title;
                trackPageView(location.pathname, title);
                if (response.instant) {
                    this.animateIn = true;
                }
                this.showSelectModel = false;
                this.$store.commit('Layout/setBrand', this.vehicle.brand);
                const spec = Object.keys(this.standardSpec);

                if (spec.length > 0) {
                    this.standardSpecSelected = spec[0];
                }

                if (this.standardSpec || this.techSpecs) {
                    try {
                        this.$nextTick(() => {
                            const specSwiper = new Swiper(this.$refs["specButtons"], {
                                modules: [Navigation],
                                grabCursor: true,
                                slidesPerView: "auto",
                                spaceBetween: 10,
                                speed: 400,
                                direction: "horizontal",
                                navigation: {
                                    prevEl: this.$refs['swiper-prev'],
                                    nextEl: this.$refs['swiper-next'],
                                },
                                on: {
                                    slideChange: () => {
                                        if (specSwiper.isBeginning) {
                                            this.$refs['swiper-prev'].classList.add('motability-details__swiper-btn--disabled');
                                            this.$refs['swiper-next'].classList.remove('motability-details__swiper-btn--disabled');
                                            return;
                                        }

                                        if (specSwiper.isEnd) {
                                            this.$refs['swiper-prev'].classList.remove('motability-details__swiper-btn--disabled');
                                            this.$refs['swiper-next'].classList.add('motability-details__swiper-btn--disabled');
                                            return;
                                        }

                                        this.$refs['swiper-prev'].classList.remove('motability-details__swiper-btn--disabled');
                                        this.$refs['swiper-next'].classList.remove('motability-details__swiper-btn--disabled');
                                    },
                                }
                            });
                            if (specSwiper.isBeginning) {
                                if (this.$refs['swiper-prev']) {
                                    this.$refs['swiper-prev'].classList.add('motability-details__swiper-btn--disabled');
                                }
                                if (this.$refs['swiper-next']) {
                                    this.$refs['swiper-next'].classList.remove('motability-details__swiper-btn--disabled');
                                }
                                return;
                            } else if (specSwiper.isEnd) {
                                if (this.$refs['swiper-prev']) {
                                    this.$refs['swiper-prev'].classList.remove('motability-details__swiper-btn--disabled');
                                }
                                if (this.$refs['swiper-next']) {
                                    this.$refs['swiper-next'].classList.add('motability-details__swiper-btn--disabled');
                                }
                                return;
                            }
                        });
                    } catch (error) {
                        console.error(error);
                    }
                }
            })
        }
    },
    computed: {
        ...mapState('NewVehicleData', ['vehicle', 'standardSpec', 'availableOptions', 'techSpecs', 'newVehiclesInStock']),

        haveNewVehiclesInStock() {
            return this.newVehiclesInStock.length > 0;
        },
        modelTitle() {
            if (this.vehicle.fuel_type != 'Electric') {
                return this.vehicle.new_model.model_title;
            }
            if (this.vehicle.new_model.electric_model_title) {
                return this.vehicle.new_model.electric_model_title;
            }

            return this.vehicle.new_model.model_title;
        },

        availableOptionsLength() {
            return this.availableOptions.length;
        },
        //
        weightAndCapacitiesData() {
            if (!this.techSpecs) {
                return false;
            }
            if (typeof this.techSpecs['Weight and Capacities'] == 'undefined') {
                return false;
            }
            return this.techSpecs['Weight and Capacities'];
        },
        luggageCapacity() {
            if (this.weightAndCapacitiesData === false) {
                return false;
            }

            let biggestLuggageCapacity = false;

            this.weightAndCapacitiesData.forEach(item => {
                if (String(item.name).indexOf('Luggage Capacity') == -1) {
                    return;
                }
                if (biggestLuggageCapacity === false || parseInt(item.value) > parseInt(biggestLuggageCapacity.value)) {
                    biggestLuggageCapacity = item;
                }
            });

            return biggestLuggageCapacity;
        },
        electricVehicleData() {
            if (this.vehicle.fuel_type != 'Electric') {
                return false;
            }
            if (!this.techSpecs) {
                return false;
            }
            if (typeof this.techSpecs['Electric Vehicle Data'] == 'undefined') {
                return false;
            }
            return this.techSpecs['Electric Vehicle Data'];
        },
        maxChargeTime() {
            if (this.electricVehicleData === false) {
                return false;
            }

            let longestChargeTime = false;
            this.electricVehicleData.forEach(item => {
                if (String(item.name).substring(0, 26) != 'Battery Charging Scenario ') {
                    return;
                }
                if (String(item.name).indexOf('Charge Time (Mins)') == -1) {
                    return;
                }
                if (longestChargeTime === false || parseInt(item.value) > parseInt(longestChargeTime.value)) {
                    longestChargeTime = item;
                }
            });

            if (longestChargeTime === false) {
                return false;
            }

            const getScernarioNumberRegex = /Battery Charging Scenario (\d+) .*/i;
            const matches = longestChargeTime.name.match(getScernarioNumberRegex);
            if (matches === null) {
                return false;
            }
            if (typeof matches[1] == 'undefined') {
                return false;
            }
            const scenarioNumber = parseInt(matches[1]);

            const maxChargeTimeData = {
                duration: longestChargeTime.value,
                powerSupply: null,
                percent: null,
            };
            this.electricVehicleData.forEach(item => {
                const getScernarioNumberRegex = /Battery Charging Scenario (\d+) .*/i;
                const matches = item.name.match(getScernarioNumberRegex);
                if (matches === null || typeof matches[1] == 'undefined' || parseInt(matches[1]) != scenarioNumber) {
                    return;
                }
                if (String(item.name).indexOf('Percentage Change') >= 0) {
                    maxChargeTimeData.percent = item.value;
                    return;
                }
                if (String(item.name).indexOf('Power Supply - kW') >= 0) {
                    maxChargeTimeData.powerSupply = item.value;
                    return;
                }
            });

            return maxChargeTimeData;
        },
        niceMaxChargeTime() {
            if (!this.maxChargeTime) {
                return false;
            }
            const duration = parseInt(this.maxChargeTime.duration);
            if (duration > 60) {
                const hours = Math.floor(duration / 60);
                const minutes = duration - (hours * 60);
                if (minutes > 0) {
                    return hours + ' hours, ' + minutes + 'mins';
                }
                return hours + ' hours';
            }
            return duration + ' mins';
        },
        maxChargeTimeMessage() {
            if (!this.maxChargeTime) {
                return false;
            }
            if (this.maxChargeTime.powerSupply !== null && this.maxChargeTime.percent !== null) {
                return 'Based on a ' + this.maxChargeTime.powerSupply + 'kW power supply, charging from ' + this.maxChargeTime.percent + '%';
            }
            if (this.maxChargeTime.percent !== null) {
                return 'Based on a ' + this.maxChargeTime.powerSupply + 'kW power supply';
            }
            if (this.maxChargeTime.powerSupply !== null) {
                return 'Based on charging from ' + this.maxChargeTime.percent + '%';
            }
            return false;
        },
        quickChargeTime() {
            if (this.electricVehicleData === false) {
                return false;
            }

            let shortestChargeTime = false;
            this.electricVehicleData.forEach(item => {
                if (String(item.name).substring(0, 26) != 'Battery Charging Scenario ') {
                    return;
                }
                if (String(item.name).indexOf('Charge Time (Mins)') == -1) {
                    return;
                }
                if (shortestChargeTime === false || parseInt(item.value) < parseInt(shortestChargeTime.value)) {
                    shortestChargeTime = item;
                }
            });

            if (shortestChargeTime === false) {
                return false;
            }

            const getScernarioNumberRegex = /Battery Charging Scenario (\d+) .*/i;
            const matches = shortestChargeTime.name.match(getScernarioNumberRegex);
            if (matches === null) {
                return false;
            }
            if (typeof matches[1] == 'undefined') {
                return false;
            }
            const scenarioNumber = parseInt(matches[1]);

            const maxChargeTimeData = {
                duration: shortestChargeTime.value,
                powerSupply: null,
                percent: null,
            };
            this.electricVehicleData.forEach(item => {
                const getScernarioNumberRegex = /Battery Charging Scenario (\d+) .*/i;
                const matches = item.name.match(getScernarioNumberRegex);
                if (matches === null || typeof matches[1] == 'undefined' || parseInt(matches[1]) != scenarioNumber) {
                    return;
                }
                if (String(item.name).indexOf('Percentage Change') >= 0) {
                    maxChargeTimeData.percent = item.value;
                    return;
                }
                if (String(item.name).indexOf('Power Supply - kW') >= 0) {
                    maxChargeTimeData.powerSupply = item.value;
                    return;
                }
            });

            return maxChargeTimeData;
        },
        niceQuickChargeTime() {
            if (!this.quickChargeTime) {
                return false;
            }
            const duration = parseInt(this.quickChargeTime.duration);
            if (duration > 60) {
                const hours = Math.floor(duration / 60);
                const minutes = duration - (hours * 60);
                if (minutes > 0) {
                    return hours + ' hours, ' + minutes + 'mins';
                }
                return hours + ' hours';
            }
            return duration + ' mins';
        },
        quickChargeTimeMessage() {
            if (!this.quickChargeTime) {
                return false;
            }
            if (this.quickChargeTime.powerSupply !== null && this.quickChargeTime.percent !== null) {
                return 'Based on a ' + this.quickChargeTime.powerSupply + 'kW power supply, charging from ' + this.quickChargeTime.percent + '%';
            }
            if (this.quickChargeTime.percent !== null) {
                return 'Based on a ' + this.quickChargeTime.powerSupply + 'kW power supply';
            }
            if (this.quickChargeTime.powerSupply !== null) {
                return 'Based on charging from ' + this.quickChargeTime.percent + '%';
            }
            return false;
        },
    },
    mounted(){
        this.init()
    },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// resources/assets/js/motability/views/motability-details.vue